const state = {
  // moduleType
  moduleType: [
    {
      value: 'layoutHeader',
      label: 'header',
      icon: 'heading',
      multiple: false
    },
    {
      value: 'layoutSlideshow',
      label: 'slideshow',
      icon: 'play',
      multiple: true
    },
    {
      value: 'layoutWeather',
      label: 'weather button',
      icon: 'cloud-sun',
      multiple: false
    },
    {
      value: 'layoutFortune',
      label: 'fortune button',
      icon: ['far', 'star'],
      multiple: false
    },
    {
      value: 'layoutCalendar',
      label: 'calender',
      icon: 'calendar-alt',
      multiple: false
    },
    {
      value: 'layoutButton',
      label: 'button',
      icon: 'square',
      multiple: true
    },
    {
      value: 'layoutList',
      label: 'list button',
      icon: 'list',
      multiple: true
    },
    {
      value: 'layoutLabel',
      label: 'label',
      icon: 'pencil-alt',
      multiple: true
    },
    {
      value: 'layoutImage',
      label: 'images',
      icon: 'image',
      multiple: true
    },
    {
      value: 'layoutPanel',
      label: 'panel',
      icon: ['far', 'square'],
      multiple: false
    },
    {
      value: 'zIndex',
      label: 'z-index',
      icon: 'layer-group',
      multiple: false
    }
  ],

  // moduleSize
  //TODO header/list高さがわかれば反映
  moduleSize: {
    // header height
    // hoam 正方形ボタン 206
    // hoam 長方形ボタン 170
    // hoambox 正方形ボタン 249
    // hoambox 長方形ボタン 195
    layoutHeader: {
      hoam: {
        width: 1280,
        height: 160
      },
      hoambox: {
        width: 1920,
        height: 200
      },
      hoamV2: {
        width: 1920,
        height: 200
      }
    },
    layoutWeather: {
      hoam : [
        // small
        {
          width: 248,
          height: 142
        },
        // large
        {
          width: 320,
          height: 180
        }
      ],
      hoambox : [
        // small
        {
          width: 329,
          height: 224
        },
        // large
        {
          width: 498,
          height: 266
        }
      ],
      hoamV2 : [
        // small
        {
          width: 329,
          height: 224
        },
        // large
        {
          width: 498,
          height: 266
        }
      ],
    },
    layoutFortune: {
      hoam : [
        // small
        {
          width: 248,
          height: 142
        },
        // large
        {
          width: 320,
          height: 180
        }
      ],
      hoambox : [
        // small
        {
          width: 329,
          height: 224
        },
        // large
        {
          width: 498,
          height: 266
        }
      ],
      hoamV2 : [
        // small
        {
          width: 329,
          height: 224
        },
        // large
        {
          width: 498,
          height: 266
        }
      ]
    },
    layoutCalendar: {
      hoam: {
        width: 226,
        height: 156
      },
      hoambox: {
        width: 339,
        height: 234
      },
      hoamV2: {
        width: 339,
        height: 234
      }
    },
    layoutList: {
      hoam : [
        // small
        {
          width: 850,
          height: 400
        },
        // large
        {
          width: 1080,
          height: 400
        }
      ],
      hoambox : [
        // small
        {
          width: 1275,
          height: 400
        },
        // large
        {
          width: 1620,
          height: 400
        }
      ],
      hoamV2 : [
        // small
        {
          width: 1275,
          height: 400
        },
        // large
        {
          width: 1620,
          height: 400
        }
      ]
    },
  },
}

const getters = {}

const actions = {}

const mutations = {}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
